import cn from 'classnames'
import styles from './TradeCrypto.module.sass'

const TradeWithCrypto = () => {
  return (
    <div className={'container'}>
      <div className={cn(styles.tradeCryptoCard)}>
        <div className="h3">Trade Crypto</div>
        <div className="h5">Try 50,000$ With Mock Trading</div>
        <button className={styles.button}>Try Now!</button>
      </div>
    </div>
  )
}

export default TradeWithCrypto
